import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import Happiness from '@/roc/effects/CultureBonus/Happiness';

const AverageHome = {
  id: "2",
  name: "Average Home",
  width: 3,
  height: 3,
  type: BuildingType.HOME,
  era: "bronzeAge",
  icon: "Worker",
  workers: 2,
  minLevel: 4,
  maxLevel: BuildingMaxLevel.THREE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Homes/Average_Home',
  flags: 0,
  counts: {
    stoneAge: null,
    bronzeAge: 2,
    minoanEra: 4,
    classicGreece: 5,
    earlyRome: 6,
    romanEmpire: 7,
    byzantineEra: 8,
    ageOfTheFranks: 9,
    feudalAge: 10,
    iberianEra: 11,
    kingdomOfSicily: 12,
    highMiddleAges: 13,
    earlyGothicEra: 14,
    lateGothicEra: 15,
  },
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asFlat(1 * 60 * 60),
      ProductionOutput
        .asPerLevel([
          0, 0, 0, 1083, 1142, 1200, 1317, 1383, 1450, 1592, 1675, 1758, 1900, 1975,
          2050, 2217, 2309, 2400, 2592, 2692, 2800, 3000, 3092, 3184, 3408, 3508,
          3617, 3867, 3983, 4100, 4383, 4517, 4650, 4975, 5125, 5275, 5500, 5833,
          6250, 6666, 7083, 7500,
        ])
        .withOutput(ProductionOutputType.GOLD),
    ),
    new Happiness({
      stoneAge: null,
      bronzeAge: [130, 250, 500],
      minoanEra: [170, 300, 670],
      classicGreece: [220, 450, 890],
      earlyRome: [280, 560, 1120],
      romanEmpire: [330, 670, 1340],
      byzantineEra: [390, 780, 1560],
      ageOfTheFranks: [470, 950, 1900],
      feudalAge: [560, 1120, 2230],
      iberianEra: [670, 1340, 2680],
      kingdomOfSicily: [810, 1620, 3230],
      highMiddleAges: [980, 1950, 3900],
      earlyGothicEra: [1170, 2340, 4680],
      lateGothicEra: [1360, 2730, 5460],
    }),
  ]),
};

export default AverageHome;
